<template>
    <f7-page
        :page-content="false"
        name="Choose your goals"
        class="onboardingBg"
    >
        <f7-navbar
            :title-large="' '"
            inner
            large
            no-hairline
            large-transparent
            inner-class="onboardingBg"
        >

            <f7-nav-left>
                <f7-link
                    v-if="!isOnboarding"
                    icon="ion-ios-arrow-left"
                    @click="saveTopicsAndGo()"
                />
            </f7-nav-left>
            <f7-nav-title>What are your goals?</f7-nav-title>
            <f7-nav-right>
                <!-- <f7-button
                    :href="'#'"
                    large
                    round
                    @click="saveTopicsAndGo()"
                >{{ myTopics.length > 0 ? 'DONE' : `SKIP` }}</f7-button> -->
            </f7-nav-right>
        </f7-navbar>
        <div :class="'bg-wrapper'">
            <div
                v-if="isOnboarding"
                class="parallax-bg"
            />

            <f7-page-content>
                <f7-block>
                    <template v-if="!isOnboarding">
                        <h2 style="padding-bottom: 10px; margin-top: -30px">Explore more goals</h2>
                        Select which goals you want to focus on or click on a goal for more detail.
                    </template>
                    <template v-else>
                        <h2 style="padding-bottom: 10px; margin-top: -30px">What are your goals?</h2>
                        Coral can change your life. Pick your goals and don't worry, you can change them later.
                    </template>
                    <br>
                    <br>
                    <br>
                    <div
                        v-for="topic in topics"
                        v-show="isEligible(topic)"
                        :style="`z-index: 11; background-color: ${topic.color || '#edeae9'}; background-repeat: repeat-x; `"
                        :class="myTopics.indexOf(topic.id) > -1 ? 'topic selected' : 'topic'"
                        :key="`topic-${topic.id}-${myTopics}`"
                    >

                        <h3 @click="goToTopic(topic.id)">
                            <span>{{ topic.name }}</span>
                        </h3>
                        <div @click="onTopicChange(topic.id)">

                            <svg
                                :class="`checkmark ${myTopics.indexOf(topic.id) > -1 ? 'checked' : ''}`"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 52 52"
                            >
                                <circle
                                    class="checkmark__circle"
                                    cx="26"
                                    cy="26"
                                    r="25"
                                    fill="none"
                                />

                            </svg>
                            <i
                                v-if="myTopics.indexOf(topic.id) > -1"
                                :style="`color: ${topic.color}`"
                                class="checkmark__check ion ion-checkmark"
                            />
                        </div>
                    </div>
                    <br>
                    <br>
                    <br>
                    <br>
                    <br>

                </f7-block>

                <f7-block
                    v-if="isOnboarding"
                    class="absBottom"
                >
                    <f7-button
                        :color="showNext() ? 'red' : 'grayer'"
                        :href="'#'"
                        fill
                        round
                        @click="saveTopicsAndGo()"
                    >{{ showNext() ? 'Continue' : `Select your goals` }}</f7-button>
                </f7-block>
            </f7-page-content>

        </div>
    </f7-page>
</template>

<script>
import utils from '../../js/utils';

export default {
    store: ['api', 'user', 'topics', 'topicsIndex', 'myTopics', 'myTraits'],
    data () {
        return {
            variant: 0,
            changingId: 0,
            isOnboarding: true,
            firstLeaveTrial: true,
        }
    },
    computed: {
        device: function () {
            return f7.device;
        }
    },
    created: function () {
        if (this.$f7route.query.fromHome) {
            this.isOnboarding = false;
        }
        this.variant = parseFloat(window.localStore.getItem(`experiment-014_goals`));
        if (this.isOnboarding && this.myTopics.length === 0 && this.user.sessions < 2) {
            if (this.variant !== 2)
                this.myTopics.unshift(58);
        }
        if (this.isOnboarding) {
            let panel = f7.panel.get('.panel-left');
            panel.params.visibleBreakpoint = 768;
            panel.disableVisibleBreakpoint();
        }
    },
    methods: {
        showNext: function () {
            if (this.isOnboarding && this.variant !== 2 && this.user.sessions < 2) {
                return this.myTopics.length > 1;
            } else {
                return this.myTopics.length > 0;
            }
        },
        goToTopic: function (topicId) {
            if (this.variant === 2 || this.isOnboarding) {
                return this.onTopicChange(topicId);
            }
            if (topicId === 58) {
                return this.$f7router.view.router.navigate(`/courses/223`);
            }
            f7.views['main'].router.navigate(`/topics/${topicId}`);
        },
        onTopicChange: function (topicId) {
            if (this.myTopics.indexOf(topicId) > -1) {
                if (topicId === 58 && this.firstLeaveTrial && this.user.unitsCompleted < 3) {
                    // this.firstLeaveTrial = false;
                    // f7.dialog.confirm('Are you sure you want to skip the introduction?', () => {
                    this.myTopics.splice(this.myTopics.indexOf(topicId), 1);
                    // });
                } else {
                    this.myTopics.splice(this.myTopics.indexOf(topicId), 1);
                }
                this.$events.fire('trackEvent', `topic_removed`, 'content', topicId, this.topicsIndex[topicId].name, this.topicsIndex[topicId]);
            } else {
                this.myTopics.push(topicId);
                this.$events.fire('trackEvent', `topic_added`, 'content', topicId, this.topicsIndex[topicId].name, this.topicsIndex[topicId]);
                this.changingId = topicId;
                setTimeout(() => {
                    this.changingId = 0;
                }, 800);
            }

        },
        isEligible: function (topic) {
            if (this.variant === 2 && topic.id === 58) return false;
            return topic.type === 'goal' &&
                utils.checkTraits(this.myTraits, topic) &&
                (!this.isOnboarding || topic.id !== 58);
        },
        saveTopicsAndGo: function () {
            if (this.variant !== 2 && this.myTopics.length < 1) return;
            this.saveMyTopics();
        },
        saveMyTopics: function () {
            if (this.isOnboarding)
                f7.views['main'].router.navigate('/home?onboarding=1', { clearPreviousHistory: true, animatePages: true, transition: 'f7-fade' });
            else
                f7.views['main'].router.back();
            setTimeout(() => {
                let panel = f7.panel.get('.panel-left');
                panel.params.visibleBreakpoint = 768;
                panel.enableVisibleBreakpoint();
                this.$http.post(`${this.api}/users/${this.user.id}/topics`, {
                    topicIds: this.myTopics
                }).then(
                    () => {
                        console.log('topics saved');
                    },
                    response => {
                        console.error(response.body.message || 'Unknown error');
                    }
                );
            }, 320);

        }
    }
};
</script>

<style lang="less" scoped>
.theme-dark {
    h2 {
        color: white;
    }
}
.topic {
    img {
        height: 120px;
        position: absolute;
        top: -15px;
        left: -20px;
        opacity: 0.7;
    }
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    border-radius: 14px;
    width: 100%;
    min-width: 240px;
    max-width: 350px;
    display: inline-block;
    height: 90px;
    background-image: url('../../img/1.4.0/goalwave.svg');
    background-size: 220px 17px;
    background-repeat: repeat-x;
    background-position: bottom right;
    transition: all 0.3 ease;
    backdrop-filter: blur(20px);
    //border: 2px solid transparent;
    h3 {
        text-align: left;
        margin-left: 30px;
        font-family: Editor-Bold;
        font-style: normal;
        font-size: 17px;
        line-height: 37px;
        color: #fff;
        padding: 0px 3px 0;
        span {
            display: inline-block;
            vertical-align: middle;
            line-height: 18px;
            padding-right: 50px;
        }
    }
    &.onHome {
        height: 120px;
        margin-right: 20px;
        min-width: 120px;
        max-width: 140px;
        h3 {
            text-align: center;
            margin-left: 0px;
            line-height: 76px;
        }
    }
}
@media only screen and (min-width: 600px) {
    .topic {
        margin-right: 10px;
    }
}
.absBottom {
    background: rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(20px);
    overflow: visible;
    // border-top: 1px solid #efefef;
    text-align: center;
    position: fixed;
    z-index: 100000;
    padding-bottom: ~'calc(6px + env(safe-area-inset-bottom))';
    width: 100%;
    margin: 0;
    bottom: 0px;
}

.checkmark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 0;
    stroke-width: 1;
    stroke-miterlimit: 10;
    stroke: rgba(255, 255, 255, 1);
    fill: rgba(255, 255, 255, 0.5);
    // animation: stroke 0s cubic-bezier(0.65, 0, 0.45, 1) forwards;
}
.checkmark {
    position: absolute;
    top: -20px;
    right: 20px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: block;
    stroke-width: 3;
    stroke: #fff;
    stroke-miterlimit: 10;
    margin: 10% auto;
    box-shadow: inset 0px 0px 0px white;

    &.checked {
        .checkmark__circle {
            fill: rgba(255, 255, 255, 1);
        }
    }
}
.checkmark.animated {
    // animation: fill 0.1s ease-in-out 0.1s forwards, scale 0.2s ease-in-out 0.4s both;
    .checkmark__circle {
        // animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;
    }
}
.checkmark__check {
    position: absolute;
    right: 30px;
    font-size: 24px;
    top: 22px;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}
@keyframes scale {
    0%,
    100% {
        transform: none;
    }
    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}
@keyframes fill {
    100% {
        box-shadow: inset 0px 0px 0px 30px rgba(255, 255, 255, 1);
    }
}
.bg-wrapper {
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
}
.parallax-bg {
    position: absolute;
    left: calc(~'-400px' - 50vw);
    top: 0;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_top.png) top right no-repeat;
    background-size: 3670.5px 171.5px;
    height: 171.5px;
    width: 3670.5px;
}
.parallax-bg-2 {
    position: absolute;
    left: calc(~'-4200px' - 50vw);
    bottom: 0px;
    background: url(https://data.getcoral.app/images/1.2.0/onboarding_bottom.png) bottom left
        no-repeat;
    background-size: 5954.5px 804px;
    height: 804px;
    width: 5954.5px;
}
</style>
